import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { GetAllLineOfPoetryDTO } from "../../dto";

type GetAllLineOfPoetryProps = {
  poetryId: number;
  page: number;
  pageSize: number;
  text?: string;
  indexOrder?: "ASC" | "DESC" | "";
};

let body: GetAllLineOfPoetryDTO;

export async function getAllLineOfPoetryAction(props: GetAllLineOfPoetryProps) {
  const token = localStorage.getItem("token");

  const params = {
    poetryId: props.poetryId,
    page: props.page,
    pageSize: props.pageSize,
    text: props.text,
    indexOrder: props.indexOrder !== "" ? props.indexOrder : undefined,
  };

  return await axios
    .get(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/lines-of-poetries/get-all`,
      {
        headers: {
          "Content-Type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
        params,
      }
    )
    .then(async (res) => {
      body = plainToClass(GetAllLineOfPoetryDTO, res.data);
      const errors = await validate(body);

      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
